"use client";

import { FC, HTMLAttributes, useEffect, useState } from "react";
import Image from "next/image";

import { trimEnd } from "lodash";
import clsx from "clsx";

// Socia share button
import {
  EmailShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import TeamsShareButton from "@/sections/blog-details/TeamsShareButton";

import icon from "@/utils/icon.helper";

// ----------------------------------------------------------------------------

export type IBlogSocialMediaHandlesProps = HTMLAttributes<HTMLDivElement> & {};

export enum ISocialMedium {
  LINKEDIN = "LI",
  TWITTER = "X",
  WHATSAPP = "WA",
}

/**
 * Get Socia Media Share Url with additional parameters
 */
const getSocialShareUrl = (
  shareUrl?: string,
  source?: string,
  medium?: ISocialMedium,
) => {
  if (!shareUrl) return "";

  const params = new URLSearchParams();
  if (source) params.set("utm_source", source);
  if (medium) params.set("utm_medium", medium);

  return params.toString()
    ? `${trimEnd(shareUrl, "/")}?${params.toString()}`
    : shareUrl;
};

const BlogSocialMediaHandles: FC<IBlogSocialMediaHandlesProps> = (props) => {
  const { className, ...other } = props;

  const [shareUrl, setShareUrl] = useState<string | undefined>();

  useEffect(() => {
    setShareUrl(window.location.href);
  }, []);

  return (
    <div className={clsx("flex flex-wrap items-center gap-2", className)} {...other}>
      <LinkedinShareButton
        url={getSocialShareUrl(shareUrl, "blog", ISocialMedium.LINKEDIN)}
      >
        <div className="rounded-sm p-1 transition-all duration-500 ease-in-out hover:bg-primary-200 hover:drop-shadow-xl">
          <Image
            src={icon("linkedin")}
            alt="social media"
            height={20}
            width={20}
            className="size-5"
          />
        </div>
      </LinkedinShareButton>
      <TwitterShareButton
        url={getSocialShareUrl(shareUrl, "blog", ISocialMedium.TWITTER)}
      >
        <div className="rounded-sm p-1 transition-all duration-500 ease-in-out hover:bg-primary-200 hover:drop-shadow-xl">
          <Image
            src={icon("twitter")}
            alt="social media"
            height={20}
            width={20}
            className="size-5"
          />
        </div>
      </TwitterShareButton>
      <WhatsappShareButton
        url={getSocialShareUrl(shareUrl, "blog", ISocialMedium.WHATSAPP)}
      >
        <div className="rounded-sm p-1 transition-all duration-500 ease-in-out hover:bg-primary-200 hover:drop-shadow-xl">
          <Image
            src={icon("whatsapp")}
            alt="social media"
            height={20}
            width={20}
            className="size-5"
          />
        </div>
      </WhatsappShareButton>

      {/* Teams share button - local component */}
      <TeamsShareButton url={getSocialShareUrl(shareUrl)} />

      <EmailShareButton url={getSocialShareUrl(shareUrl)}>
        <div className="rounded-sm p-1 transition-all duration-500 ease-in-out hover:bg-primary-200 hover:drop-shadow-xl">
          <Image
            src={icon("gmail")}
            alt="social media"
            height={20}
            width={20}
            className="size-5"
          />
        </div>
      </EmailShareButton>
    </div>
  );
};

export default BlogSocialMediaHandles;
